var braSizeCalculate = function ( underbust, overbust ) {
    var size = false;
  	underbust = underbust * 1;
    overbust = overbust * 1; 
  	/*console.log(typeof underbust);
    console.log(typeof overbust);*/
    if ( underbust < 63 || underbust > 107 )
        size = false;


    if ( underbust >= 63 && underbust <= 67 ) {
        if ( overbust < 75 || overbust >= 100 ) size = false;
        if ( overbust >= 75 && overbust < 76 ) size = '30AA';
        if ( overbust >= 77 && overbust < 79 ) size = '30A';
        if ( overbust >= 79 && overbust < 81 ) size = '30B';
        if ( overbust >= 81 && overbust < 83 ) size = '30C';
        if ( overbust >= 83 && overbust < 85 ) size = '30D';
        if ( overbust >= 85 && overbust < 88 ) size = '30DD';
        if ( overbust >= 88 && overbust < 91 ) size = '30E';
        if ( overbust >= 92 && overbust < 95 ) size = '30F';
        if ( overbust >= 96 && overbust < 99 ) size = '30FF';
        if ( overbust >= 100 && overbust < 103 ) size = '30G';
    }
    if ( underbust >= 68 && underbust <= 72 ) {
        if ( overbust < 80 || overbust >= 106 )  size = false;
        if ( overbust >= 80 && overbust < 82 )   size = '32AA';
        if ( overbust >= 82 && overbust < 84 )   size = '32A';
        if ( overbust >= 84 && overbust < 86 )   size = '32B';
        if ( overbust >= 86 && overbust < 88 )   size = '32C';
        if ( overbust >= 88 && overbust < 90 )   size = '32D';
        if ( overbust >= 90 && overbust < 93 )   size = '32DD';
        if ( overbust >= 94 && overbust < 97 )   size = '32E';
        if ( overbust >= 98 && overbust < 100 )  size = '32F';
        if ( overbust >= 101 && overbust < 104 ) size = '32FF';
        if ( overbust >= 105 && overbust < 108 ) size = '32G';
    }
    if ( underbust >= 73 && underbust <= 77 ) {
        if ( overbust < 85 || overbust >= 115 )  size = false;
        if ( overbust >= 85 && overbust < 87 )   size = '34AA';
        if ( overbust >= 87 && overbust < 89 )   size = '34A';
        if ( overbust >= 89 && overbust < 91 )   size = '34B';
        if ( overbust >= 91 && overbust < 93 )   size = '34C';
        if ( overbust >= 93 && overbust < 96 )   size = '34D';
        if ( overbust >= 97 && overbust < 100 )  size = '34DD';
        if ( overbust >= 101 && overbust < 104 ) size = '34E';
        if ( overbust >= 105 && overbust < 108 ) size = '34F';
        if ( overbust >= 109 && overbust < 112 ) size = '34FF';
        if ( overbust >= 113 && overbust < 116 ) size = '34G';
    }
    if ( underbust >= 78 && underbust <= 82 ) {
        if ( overbust < 92 || overbust >= 121 )  size = false;
        if ( overbust >= 92 && overbust < 94 )   size = '36A';
        if ( overbust >= 94 && overbust < 96 )   size = '36B';
        if ( overbust >= 96 && overbust < 98 )   size = '36C';
        if ( overbust >= 98 && overbust < 101 )  size = '36D';
        if ( overbust >= 102 && overbust < 105 ) size = '36DD';
        if ( overbust >= 106 && overbust < 109 ) size = '36E';
        if ( overbust >= 110 && overbust < 113 ) size = '36F';
        if ( overbust >= 114 && overbust < 117 ) size = '36FF';
        if ( overbust >= 118 && overbust < 121 ) size = '36G';
    }
    if ( underbust >= 83 && underbust <= 87 ) {
        if ( overbust < 97 || overbust >= 126 )  size = false;
        if ( overbust >= 97 && overbust < 99 )   size = '38A';
        if ( overbust >= 89 && overbust < 101 )  size = '38B';
        if ( overbust >= 101 && overbust < 103 ) size = '38C';
        if ( overbust >= 103 && overbust < 106 ) size = '38D';
        if ( overbust >= 107 && overbust < 110 ) size = '38DD';
        if ( overbust >= 111 && overbust < 114 ) size = '38E';
        if ( overbust >= 115 && overbust < 118 ) size = '38F';
        if ( overbust >= 119 && overbust < 122 ) size = '38FF';
        if ( overbust >= 123 && overbust < 126 ) size = '38G';
    }
    if ( underbust >= 88 && underbust <= 92 ) {
        if ( overbust < 102 || overbust >= 131 ) size = false;
        if ( overbust >= 102 && overbust < 104 ) size = '40A';
        if ( overbust >= 104 && overbust < 106 ) size = '40B';
        if ( overbust >= 106 && overbust < 108 ) size = '40C';
        if ( overbust >= 108 && overbust < 111 ) size = '40D';
        if ( overbust >= 112 && overbust < 115 ) size = '40DD';
        if ( overbust >= 116 && overbust < 119 ) size = '40E';
        if ( overbust >= 120 && overbust < 123 ) size = '40F';
        if ( overbust >= 124 && overbust < 127 ) size = '40FF';
        if ( overbust >= 128 && overbust < 131 ) size = '40G';
    }
    if ( underbust >= 93 && underbust <= 97 ) {
        if ( overbust < 107 || overbust >= 136 ) size = false;
        if ( overbust >= 107 && overbust < 109 ) size = '42A';
        if ( overbust >= 109 && overbust < 111 ) size = '42B';
        if ( overbust >= 111 && overbust < 113 ) size = '42C';
        if ( overbust >= 113 && overbust < 116 ) size = '42D';
        if ( overbust >= 117 && overbust < 120 ) size = '42DD';
        if ( overbust >= 121 && overbust < 124 ) size = '42E';
        if ( overbust >= 125 && overbust < 128 ) size = '42F';
        if ( overbust >= 129 && overbust < 132 ) size = '42FF';
        if ( overbust >= 133 && overbust < 136 ) size = '42G';
    }
    if ( underbust >= 98 && underbust <= 102 ) {
        if ( overbust < 112 || overbust >= 141 ) size = false;
        if ( overbust >= 112 && overbust < 114 ) size = '44A';
        if ( overbust >= 114 && overbust < 116 ) size = '44B';
        if ( overbust >= 116 && overbust < 118 ) size = '44C';
        if ( overbust >= 118 && overbust < 121 ) size = '44D';
        if ( overbust >= 122 && overbust < 125 ) size = '44DD';
        if ( overbust >= 126 && overbust < 129 ) size = '44E';
        if ( overbust >= 130 && overbust < 133 ) size = '44F';
        if ( overbust >= 134 && overbust < 137 ) size = '44FF';
        if ( overbust >= 136 && overbust < 141 ) size = '44G';
    }
    if ( underbust >= 103 && underbust <= 107 ) {
        if ( overbust < 119 || overbust >= 143 ) size = false;
        if ( overbust >= 119 && overbust < 121 ) size = '46B';
        if ( overbust >= 121 && overbust < 123 ) size = '46C';
        if ( overbust >= 123 && overbust < 126 ) size = '46D';
        if ( overbust >= 127 && overbust < 130 ) size = '46DD';
        if ( overbust >= 131 && overbust < 134 ) size = '46E';
        if ( overbust >= 135 && overbust < 136 ) size = '46F';
        if ( overbust >= 139 && overbust < 142 ) size = '46FF';
        if ( overbust >= 143 && overbust < 146 ) size = '46G';

    }
/*    if ( underbust > 107 && underbust <= 111 ) {
        if ( overbust < 124 || overbust >= 148 ) size = false;
        if ( overbust >= 124 && overbust < 126 ) size = '48B';
        if ( overbust >= 126 && overbust < 128 ) size = '48C';
        if ( overbust >= 128 && overbust < 130 ) size = '48D';
        if ( overbust >= 130 && overbust < 132 ) size = '48DD';
        if ( overbust >= 132 && overbust < 134 ) size = '48E';
        if ( overbust >= 134 && overbust < 136 ) size = '48F';
        if ( overbust >= 136 && overbust < 138 ) size = '48FF';
        if ( overbust >= 138 && overbust < 140 ) size = '48G';
        if ( overbust >= 140 && overbust < 142 ) size = '48GG';
        if ( overbust >= 142 && overbust < 144 ) size = '48H';
        if ( overbust >= 144 && overbust < 146 ) size = '48HH';
        if ( overbust >= 146 && overbust < 148 ) size = '48J';
    }*/
  	
  	//console.log(size);
    return size;
}